export default __webpack_public_path__ + "static/media/dog-red.f6568060.svg";